import React from 'react';
import { Box, Chip, Tooltip } from '@mui/material';
import { Channel } from 'bloggers-backend/lib/youtube/domain/SearchTask';
import { getChannelSocialLinks, SOCIAL_NETWORKS, SocialNetwork } from './channelFilters';
import { stripUrlScheme, withUrlScheme } from './channelFormat';

const NETWORK_LABELS: Record<SocialNetwork, string> = {
  instagram: 'IG',
  facebook: 'FB',
  tikTok: 'TT',
};

const compactChipSx = {
  height: 20,
  fontSize: 11,
  '& .MuiChip-label': { paddingLeft: '6px', paddingRight: '6px' },
};

interface ContactsCellProps {
  channel: Channel;
}

export function ContactsCell({ channel }: ContactsCellProps) {
  const emailChip = channel.hasBusinessEmail === true
    ? <Chip key="email" label="Email" size="small" color="success" sx={compactChipSx} />
    : channel.hasBusinessEmail === false
      ? null
      : <Chip key="email" label="Email ?" size="small" color="warning" sx={compactChipSx} />;

  const socialChips = SOCIAL_NETWORKS.map((network) => {
    const links = getChannelSocialLinks(channel, network);
    if (links.length === 0) {
      return null;
    }
    const label = links.length > 1 ? `${NETWORK_LABELS[network]} x${links.length}` : NETWORK_LABELS[network];
    return (
      <Tooltip key={network} title={links.map(stripUrlScheme).join(', ')}>
        <Chip
          label={label}
          size="small"
          clickable
          component="a"
          href={withUrlScheme(links[0])}
          target="_blank"
          rel="noreferrer"
          sx={compactChipSx}
        />
      </Tooltip>
    );
  });

  return (
    <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center', overflow: 'hidden' }}>
      {emailChip}
      {socialChips}
    </Box>
  );
}
